<template>
  <div class="pay-success-container">
    <div class="pay-success-card">
      <div v-if="loading" class="pay-success-loading-box">
        <i class="el-icon-loading pay-success-loading"></i>
        <div class="pay-success-loading-text">支付处理中，请稍候…</div>
      </div>
      <template v-else>
        <div class="pay-success-icon-box">
          <i class="el-icon-circle-check pay-success-icon"></i>
        </div>
        <div class="pay-success-title">支付成功</div>
        <div class="pay-success-desc">感谢您的购买，订单已成功支付！</div>

        <!-- 订单信息展示 -->
        <div class="pay-success-info">
          <!-- 单个商品订单 (order_id) -->
          <template v-if="order_id && detail">
            <div class="order-header">
              <i class="el-icon-shopping-cart-2"></i>
              <span>订单详情</span>
            </div>
            <div class="pay-success-info-row">
              <span class="pay-success-label">订单号：</span>
              <span class="pay-success-value">{{ detail.orderno || '暂无' }}</span>
            </div>
            <div class="pay-success-info-row">
              <span class="pay-success-label">商品名称：</span>
              <span class="pay-success-value">{{ detail.product_name || '暂无' }}</span>
            </div>
            <div class="pay-success-info-row">
              <span class="pay-success-label">CAS号：</span>
              <span class="pay-success-value">{{ detail.cas_no || '暂无' }}</span>
            </div>
            <div class="pay-success-info-row">
              <span class="pay-success-label">商品价格：</span>
              <span class="pay-success-value">￥{{ detail.unit_price || '0.00' }}</span>
            </div>
            <div class="pay-success-info-row">
              <span class="pay-success-label">商品数量：</span>
              <span class="pay-success-value">{{ detail.cart_num || 0 }}</span>
            </div>
            <div class="pay-success-info-row">
              <span class="pay-success-label">总金额：</span>
              <span class="pay-success-value pay-success-total">￥{{ detail.total_price || '0.00' }}</span>
            </div>
          </template>

          <!-- 多个商品订单 (order_no) -->
          <template v-else-if="order_no && productList.length > 0">
            <div class="order-header">
              <i class="el-icon-shopping-cart-2"></i>
              <span>订单详情</span>
            </div>
            <div class="pay-success-info-row">
              <span class="pay-success-label">订单号：</span>
              <span class="pay-success-value">{{ order_no }}</span>
            </div>

            <!-- 商品列表 -->
            <div class="product-list">
              <div class="product-list-title">商品清单</div>
              <div
                class="product-item"
                v-for="(item, index) in productList"
                :key="index"
              >
                <div class="product-info">
                  <div class="product-name">{{ item.product_name  }}</div>
                  <div class="product-cas">CAS: {{ item.cas_no || '暂无' }}</div>
                </div>
                <div class="product-price">
                  <div class="price">￥{{ item.unit_price || '0.00' }}</div>
                  <div class="quantity">x{{ item.cart_num || 0 }}</div>
                </div>
                <div class="product-total">
                  ￥{{ item.total_price || '0.00' }}
                </div>
              </div>
            </div>

            <div class="pay-success-info-row total-row">
              <span class="pay-success-label">总金额：</span>
              <span class="pay-success-value pay-success-total">￥{{ total_price || '0.00' }}</span>
            </div>
          </template>
        </div>

        <div class="pay-success-actions">
          <el-button type="primary" size="medium" @click="goOrder">查看订单</el-button>
          <el-button size="medium" @click="goShop">返回商城</el-button>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { get_order_by_orderid, get_order_by_orderno } from "@/api/modules/user";
export default {
  name: "PaySuccess",
  data() {
    return {
      loading: true, // 控制等待动画显示
      order_no: this.$route.query.order_no,
      order_id: this.$route.query.order_id,
      detail: {},
      productList: [],
      total_price: 0,
    };
  },
  watch: {
    productList() {
      return this.productList.map(item => ({
        ...item,
        total_price: (item.unit_price * item.cart_num).toFixed(2)
      }));
    }
  },
  mounted() {
    // 模拟支付处理 1 秒后显示成功
    setTimeout(() => {
      this.loading = false;
    }, 1000);
    if (this.order_id) {
      this.getOrderInfo();
    } else if (this.order_no) {
      this.getOrderInfoByNo();
    }

    // 设置页面标题
    document.title = '支付成功 - 化联网';

    // 添加新窗口的样式优化
    if (window.opener) {
      // 如果是从其他窗口打开的，添加一些特殊样式
      document.body.classList.add('new-window');
    }
  },
  methods: {
    // 立即购买下单 - 单个商品对象
    getOrderInfo() {
      this.loading = true;
      get_order_by_orderid(this.order_id).then((res) => {
        this.detail = res.data.data;
        this.loading = false;
      }).catch((error) => {
        this.loading = false;
      });
    },
    // 购物车下单 - 多个商品数组
    getOrderInfoByNo() {
      this.loading = true;
      get_order_by_orderno(this.order_no).then((res) => {
        this.productList = res.data.data.list || [];
        this.total_price = res.data.data.total_price || 0;
        this.loading = false;
      }).catch((error) => {
        this.loading = false;
      });
    },
    goOrder() {
      this.$router.push("/user/purchase/order");
    },
    goShop() {
      this.$router.push("/shop");
    },
  },
};
</script>

<style scoped>
.pay-success-container {
  min-height: 100vh;
  /* background: linear-gradient(80deg, #667eea 0%, #4b86a2 50%, #93e6fb 100%); */
  background-image: url("../../../static/index/message-bj.png");
  /* background-size: 100% 100%; */
  background-size: 100% 100%;
  animation: gradientShift 15s ease infinite;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
}

.pay-success-container::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><defs><pattern id="grain" width="100" height="100" patternUnits="userSpaceOnUse"><circle cx="25" cy="25" r="1" fill="rgba(255,255,255,0.1)"/><circle cx="75" cy="75" r="1" fill="rgba(255,255,255,0.1)"/><circle cx="50" cy="10" r="0.5" fill="rgba(255,255,255,0.1)"/><circle cx="10" cy="60" r="0.5" fill="rgba(255,255,255,0.1)"/><circle cx="90" cy="40" r="0.5" fill="rgba(255,255,255,0.1)"/></pattern></defs><rect width="100" height="100" fill="url(%23grain)"/></svg>');
  opacity: 0.3;
  pointer-events: none;
}

@keyframes gradientShift {
  0% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
  100% { background-position: 0% 50%; }
}

.pay-success-card {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border-radius: 24px;
  box-shadow:
    0 20px 60px rgba(0, 0, 0, 0.15),
    0 8px 32px rgba(64, 158, 255, 0.1),
    inset 0 1px 0 rgba(255, 255, 255, 0.8);
  padding: 48px 40px 32px 40px;
  max-width: 480px;
  width: 100%;
  text-align: center;
  animation: fadeInUp 0.8s cubic-bezier(0.23, 1.01, 0.32, 1) both;
  border: 1px solid rgba(255, 255, 255, 0.2);
  position: relative;
  z-index: 1;
}

@keyframes fadeInUp {
  0% {
    opacity: 0;
    transform: translateY(60px) scale(0.95);
  }
  100% {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.pay-success-icon-box {
  margin-bottom: 24px;
}

.pay-success-icon {
  font-size: 72px;
  color: #67c23a;
  background: linear-gradient(135deg, #e8f7e0 0%, #d4edda 100%);
  border-radius: 50%;
  padding: 20px;
  box-shadow:
    0 8px 32px rgba(103, 194, 58, 0.2),
    0 4px 16px rgba(103, 194, 58, 0.1);
  animation: iconPulse 2s ease-in-out infinite;
}

@keyframes iconPulse {
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.05); }
}

.pay-success-title {
  font-size: 32px;
  font-weight: 700;
  color: #2c3e50;
  margin-bottom: 12px;
  background: #67c23a;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.pay-success-desc {
  font-size: 16px;
  color: #7f8c8d;
  margin-bottom: 32px;
  line-height: 1.6;
}

.pay-success-info {
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  border-radius: 16px;
  padding: 24px;
  margin-bottom: 32px;
  text-align: left;
  border: 1px solid rgba(226, 232, 240, 0.8);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.05);
}

.order-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 20px;
  padding-bottom: 12px;
  border-bottom: 2px solid #e2e8f0;
  color: #475569;
  font-weight: 600;
  font-size: 16px;
}

.order-header i {
  color: #409eff;
  font-size: 18px;
}

.pay-success-info-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 15px;
  color: #334155;
  margin-bottom: 12px;
  padding: 8px 0;
  border-bottom: 1px solid rgba(226, 232, 240, 0.5);
}

.pay-success-info-row:last-child {
  border-bottom: none;
  margin-bottom: 0;
}

.pay-success-label {
  color: #64748b;
  font-weight: 500;
}

.pay-success-value {
  font-weight: 600;
  color: #1e293b;
}

.pay-success-total {
  color: #409eff;
  font-size: 20px;
  font-weight: 700;
}

.total-row {
  margin-top: 16px;
  padding-top: 16px;
  border-top: 2px solid #e2e8f0;
  font-size: 18px;
}

.product-list {
  margin: 20px 0;
}

.product-list-title {
  font-size: 16px;
  font-weight: 600;
  color: #475569;
  margin-bottom: 16px;
  padding-bottom: 8px;
  border-bottom: 1px solid #e2e8f0;
}

.product-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 0;
  border-bottom: 1px solid rgba(226, 232, 240, 0.5);
}

.product-item:last-child {
  border-bottom: none;
}

.product-info {
  flex: 1;
  text-align: left;
}

.product-name {
  font-size: 15px;
  font-weight: 600;
  color: #1e293b;
  margin-bottom: 4px;
}

.product-cas {
  font-size: 13px;
  color: #64748b;
}

.product-price {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  margin: 0 16px;
}

.price {
  font-size: 15px;
  font-weight: 600;
  color: #1e293b;
}

.quantity {
  font-size: 13px;
  color: #64748b;
  margin-top: 2px;
}

.product-total {
  font-size: 16px;
  font-weight: 700;
  color: #409eff;
  min-width: 80px;
  text-align: right;
}

.pay-success-actions {
  margin-top: 24px;
  display: flex;
  justify-content: center;
  gap: 16px;
}

.pay-success-actions .el-button {
  padding: 12px 24px;
  font-size: 16px;
  border-radius: 12px;
  transition: all 0.3s ease;
}

.pay-success-actions .el-button--primary {
  background: linear-gradient(135deg, #409eff 0%, #66b1ff 100%);
  border: none;
  box-shadow: 0 4px 16px rgba(64, 158, 255, 0.3);
}

.pay-success-actions .el-button--primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(64, 158, 255, 0.4);
}

.pay-success-loading-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 300px;
  margin-bottom: 10px;
}

.pay-success-loading {
  font-size: 64px;
  color: #409eff;
  margin-bottom: 20px;
  animation: rotate 1.2s linear infinite;
}

.pay-success-loading-text {
  font-size: 18px;
  color: #64748b;
  letter-spacing: 1px;
  font-weight: 500;
}

@keyframes rotate {
  100% {
    transform: rotate(360deg);
  }
}

/* 响应式设计 */
@media (max-width: 768px) {
  .pay-success-card {
    margin: 20px;
    padding: 32px 24px 24px 24px;
    max-width: 100%;
  }

  .pay-success-title {
    font-size: 28px;
  }

  .pay-success-info {
    padding: 20px;
  }

  .pay-success-actions {
    flex-direction: column;
    gap: 12px;
  }

  .product-item {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }

  .product-price {
    align-items: flex-start;
    margin: 0;
  }

  .product-total {
    align-self: flex-end;
  }
}

@media (max-width: 480px) {
  .pay-success-container {
    padding: 10px;
  }

  .pay-success-card {
    padding: 24px 20px 20px 20px;
  }

  .pay-success-icon {
    font-size: 56px;
    padding: 16px;
  }

  .pay-success-title {
    font-size: 24px;
  }
}
</style>
